module.exports = __webpack_public_path__ + "media/images/business/i-matching-67b9cd6093e45ae1753f3cf9df37a4c5.svg";